import { SIGNUP_URL, WALKTHROUGH_URL } from "../data";
import { track } from "@/lib/analytics";

export default function ProductsCta() {
  return (
    <section className="relative bg-background-100 overflow-hidden border-t border-background-300/20">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[720px] h-[440px] rounded-full joble-glow-accent"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 py-20 md:py-24 text-center">
        <h2 className="reveal font-heading text-4xl sm:text-5xl font-medium text-foreground-950 leading-[1.1] tracking-tight">
          See all three working together.
        </h2>
        <p className="reveal mt-6 text-base md:text-lg text-foreground-700 leading-relaxed max-w-xl mx-auto">
          Want it walked through for your business first? Book a walkthrough. Want to get your hands
          on it right now? Try it free.
        </p>

        <div className="reveal mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("try_joble_clicked", { location: "products_cta_primary" })}
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 rounded-full bg-primary-500 text-foreground-950 font-semibold text-base px-9 py-4 hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Try Joble Now
            <span className="w-7 h-7 rounded-full bg-foreground-950/15 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
              <i className="ri-arrow-right-line text-foreground-950" aria-hidden></i>
            </span>
          </a>
          <a
            href={WALKTHROUGH_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("book_demo_clicked", { location: "products_cta_secondary" })}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border border-background-300/60 text-foreground-900 font-semibold text-base px-9 py-4 hover:bg-background-50/70 transition-colors cursor-pointer whitespace-nowrap"
          >
            Book a Demo
          </a>
        </div>
      </div>
    </section>
  );
}